export const REACT_PRINT_CLASSNAMES = {
    MODULE: 'printclass-module',
    MODULE_DETAILS: 'printclass-module-details-container',
    MODULE_PRINT_BUTTON: 'printclass-print-button',
};
